import type { AssemblyCurrency } from './currency';
import type { MemberDetails, ReactionDetails } from './flowTypes';

export enum ClaimStatus {
  Pending = 'pending',
  Approved = 'approved',
  Denied = 'denied',
}

export type ChallengeState =
  | 'ACTIVE'
  | 'INACTIVE'
  | 'CLOSED'
  | 'QUEUED'
  | 'ARCHIVED';

export type Claim = {
  claimId: string;
  points: number;
  state: 'PENDING' | 'APPROVED' | 'DENIED';
};

export type SelfClaimDetails = {
  totalCount: number;
  totalEarnedPoints: number;
  claims: Claim[];
};

export type ChallengeCardClaimState = 'Claimed' | 'Pending';

export type ChallengeAPIResponse = {
  title: string;
  points: number;
  canEdit: boolean;
  type: 'STANDALONE';
  launchedAt: string;
  challengeId: string;
  state: ChallengeState;
  claimsRemaining: number;
  claimButtonText: string;
  createdBy: MemberDetails;
  reactions: ReactionDetails[];
  selfClaimDetails?: SelfClaimDetails;
  description: {
    messageHtml: string;
  };
  interactionSettings?: {
    hideReplies: boolean;
    hideReactions: boolean;
  };
  proof: ChallengeProof;
};

export type UserAvatar = {
  name: string;
  memberID: string;
  image?: string | undefined;
};

export type ChallengeDetails = {
  id: string;
  title: string;
  description?: string;
  state: ChallengeState;
  points: number;
  launchedAt?: string;
  currency?: AssemblyCurrency;
  image?: string;
  proof: ChallengeProof;
};

export type ChallengeProof = {
  isRequired: boolean;
  content?: {
    type: 'TEXT' | 'FILE';
    promptText: string;
  }[];
};

export type SubmitClaimFormType =
  | 'onlyOpenEnded'
  | 'onlyFileUpload'
  | 'fileUploadAndOpenEnded';

export type SubmitClaimFormDetails = {
  formType: SubmitClaimFormType;
  textFieldLabel?: string;
  fileFieldLabel?: string;
};
